import { getApis } from '../../library/Apis';
import { toRequest } from '../../utils/RequestUtils';

export const RESETED_COORDENADORES = 'RESETED_COORDENADORES';
export const CHANGE_COORDENADOR_STATUS_ACTION =
  'CHANGE_COORDENADOR_STATUS_ACTION';
export const SAVED_COORDENADOR_ACTION = 'SAVED_COORDENADOR_ACTION';
export const LOADED_COORDENADOR_ACTION = 'LOADED_COORDENADOR_ACTION';
export const CLEARED_COORDENADORES_PAGE_ACTION =
  'CLEARED_COORDENADORES_PAGE_ACTION';
export const LOADED_COORDENADORES_PAGE_ACTION =
  'LOADED_COORDENADORES_PAGE_ACTION';
export const CLEARED_COORDENADOR_ACTION = 'CLEARED_COORDENADOR_ACTION';
export const CHANGED_COORDENADOR_EDITING_VALUE_ACTION =
  'CHANGED_COORDENADOR_EDITING_VALUE_ACTION';
export const REMOVING_COORDENADOR_ACTION = 'REMOVING_COORDENADOR_ACTION';
export const SET_CORDENADOR_NAME = 'SET_CORDENADOR_NAME';
export const SET_ASSESSOR_NAME = 'SET_ASSESSOR_NAME';
export const SET_NAME = 'SET_NAME';

export const setCordenadorName = (name) => ({
  type: SET_CORDENADOR_NAME,
  payload: name,
});

export const setName = (nameType, nameValue) => ({
  type: SET_NAME,
  payload: {
    type: nameType,
    value: nameValue,
  },
});

const getEndpoint = () => {
  return getApis().apis.bff + 'v1/coordenador-local';
};

export const resetCoordenadoresReducer = () => ({
  type: RESETED_COORDENADORES,
  payload: null,
});

export const clearCoordenadoresPageList = () => ({
  type: CLEARED_COORDENADORES_PAGE_ACTION,
  payload: null,
});

export const loadCoordenadoresPaginado = (
  postData,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    const ensureArray = (data) => (Array.isArray(data) ? data : []);
    postData.estados = ensureArray(postData.estados);
    postData.cidades = ensureArray(postData.cidades);
    postData.escolas = ensureArray(postData.escolas);
    const url = `${getEndpoint()}/page?page=${postData.page}&size=${postData.size
      }`;
    const { ...bodyData } = postData;
    toRequest(
      'post',
      [url, bodyData],
      'coordenadoresPaginado'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_COORDENADORES_PAGE_ACTION,
          payload: {
            ...resp.data,
            busca: postData.busca,
            page: postData.page,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp.data);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const changeCoordenadorStatus = (
  cpf,
  status,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    toRequest(
      'put',
      [`${getEndpoint()}/${cpf}/status/${status}`],
      'save'
    ).then(
      () => {
        dispatch({
          type: CHANGE_COORDENADOR_STATUS_ACTION,
          payload: {
            cpf,
            status,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const clearCoordenadorEditing = () => ({
  type: CLEARED_COORDENADOR_ACTION,
  payload: null,
});

export const changeCoordenadorEditingValue = (name, value) => {
  if (typeof value === 'string') {
    if (value.trim().length > 0) {
      return {
        type: CHANGED_COORDENADOR_EDITING_VALUE_ACTION,
        payload: { name, value },
      };
    } else {
      return {
        type: CHANGED_COORDENADOR_EDITING_VALUE_ACTION,
        payload: { name, value: '' },
      };
    }
  }
  return {
    type: CHANGED_COORDENADOR_EDITING_VALUE_ACTION,
    payload: { name, value },
  };
};

export const loadCoordenadorByCPF = (cpf, callbackSuccess, callbackError) => {
  return (dispatch) => {
    toRequest(
      'get',
      [`${getEndpoint()}/${cpf}`],
      'coordenador'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_COORDENADOR_ACTION,
          payload: {
            ...resp.data,
            coop: resp.data.coop || resp.data.codCoop,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const saveCoordenadorByCPF = (
  coordenador,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    toRequest(
      'put',
      [`${getEndpoint()}`, coordenador],
      'save'
    ).then(
      (resp) => {
        dispatch({
          type: SAVED_COORDENADOR_ACTION,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const deleteCoordenadorLocal = (cpf, callbackSuccess, callbackError) => {
  return (dispatch) => {
    dispatch({
      type: REMOVING_COORDENADOR_ACTION,
      payload: true,
    });
    toRequest('delete', [`${getEndpoint()}/${cpf}`], 'save').then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: REMOVING_COORDENADOR_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};
